import React, { useState, useEffect } from "react";
import useDisplay from "../../../hooks/useDisplay";

function Checkbox({ size, checked, onChange }) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  return (
    <>
      {checked ? (
        <img
          onClick={onChange}
          src="/assets/icons/check_a_20.png"
          style={{
            height: size ? size : isMobile ? 14 : 20,
            width: size ? size : isMobile ? 14 : 20,
            cursor: "pointer",
          }}
        />
      ) : (
        <img
          onClick={onChange}
          src="/assets/icons/check_d_20.png"
          style={{
            height: size ? size : isMobile ? 14 : 20,
            width: size ? size : isMobile ? 14 : 20,
            cursor: "pointer",
          }}
        />
      )}
    </>
  );
}

export default Checkbox;
